import { Kommuter } from "./Kommuter";

export const kommuter = new Kommuter();

// @ts-ignore
window.kommuter = kommuter;
